angular.module('impactx.budget').controller('BudgetListCtrl', [
    'selectedListItems',
    'DownloadService',
    'BudgetImportService',
    '$scope',
    BudgetListCtrl
]);

function BudgetListCtrl(selectedListItems, DownloadService, BudgetImportService, $scope) {
    var ctrl = this;

    this.importBudget = function (event, trns) {
        BudgetImportService.showUploadDialog(event, trns, '/budget/import');
    };

    this.exportBudget = function () {
        DownloadService.openDownloadPost('/budget/export', {paramName: 'listConfig', paramValue: $scope.$$childHead.metaData.params.listConfig});
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditBudget'
        },
        {
            label: "import",
            action: ctrl.importBudget,
            condition: selectedListItems.isNoSelection,
            process: 'ImportBudgets'
        },
        {
            label: "export",
            action: ctrl.exportBudget,
            condition: selectedListItems.isNoSelection,
            process: 'ExportBudgets'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/budget/templates/budgetlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/budget/list',
        id: "budgetlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "budget/" + selectedListItems.getFirstSelectedId();
    }
}